module.exports = __webpack_public_path__ + "img/thumnail-iwt-conven-feet.3d988b70.webp";